<script setup lang="ts">
import { Coverage } from "@/interfaces/product.interface";
import { EyeIcon } from "@heroicons/vue/outline";

defineProps<{
  coverage: Coverage;
}>();

defineEmits(["openModal"]);
</script>

<template>
  <li
    class="font-bold font-montserrat text-grayDetails-400 text-xs md:text-[15px] w-full flex justify-between items-center"
  >
    <div class="flex flex-col">
      <h3 class="text-grayDetails-400 font-bold">{{ coverage.title }}</h3>
      <div
        :class="[
          coverage.is_telemedicine ? 'flex justify-between' : 'flex flex-col',
        ]"
      >
        <template v-if="coverage.is_telemedicine">
          <div class="text-greenStatus-200 text-xs md:text-primary mt-2">
            <span>Disponibles: </span>
            <span class="font-bold"
              >{{ coverage.available_cant }} videoconsultas</span
            >
          </div>
        </template>
        <template v-else>
          <div class="text-grayDetails-400 text-xs md:text-primary mt-2">
            Saldo total:
            <span class="font-bold">$ {{ coverage.amount }}</span>
          </div>
          <div class="text-greenStatus-200 text-xs md:text-primary mt-2">
            Saldo disponible:
            <span class="font-bold">$ {{ coverage.available_amount }}</span>
          </div>
        </template>
      </div>
    </div>
    <div>
      <EyeIcon
        @click="$emit('openModal', coverage)"
        class="text-grayDetails-200 cursor-pointer w-4 h-4 md:w-[24px] md:h-[24px] hover:text-skin-major"
      />
    </div>
  </li>
</template>

<style scoped></style>
